/* global self */
import { default as focusWithinInit } from './browser';
self.focusWithinInit = focusWithinInit;
